import { KYMW0900Model } from '../kymw0900.model';
import { PublishVoiceHistoryRequestModel } from '../vo/kymw0900-publish-voice-history-request.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声掲載履歴検索サービス
 *
 * @export GetPublishVoiceHistoryService
 * @class PlessJsonResponderSub
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPublishVoiceHistoryService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetPublishVoiceHistoryService
   */

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPublishVoiceHistoryService
   */
  private successFunc: Function;

  public model: KYMW0900Model;

  private vo: PublishVoiceHistoryRequestModel = null;
  private numSelect: number = <number>0;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishVoiceHistoryService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        Rec: {
          parameter: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
            ReceiptNum: this.vo.receiptNum,
          },
          combination: this.vo.coopInfoList.map(coopInfo => {
            // 会員生協情報セット追加
            return {
              condition: {
                CoopCode: coopInfo.CoopCode,
                CoopSelect: coopInfo.CoopSelect
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPublishVoiceHistoryService
   */
  execute(model: any, vo: PublishVoiceHistoryRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPublishVoiceHistory', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishVoiceHistoryService
   */
  success(data: any): void {
    if (data !== null) {
      // 返却情報が1件のみ
      if (data.length === 1) {
        // 各生協の場合
        this.model.copyVoiceHistory(data, this.checkNumSelect());
      } else {
        // 一括の場合
        this.model.copyVoiceHistoryAll(data);
      }
    }
  }

  private checkNumSelect(): number {
    switch (this.vo.coopInfoList[0].CoopCode) {
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_IB:
        this.numSelect = 0;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_TO:
        this.numSelect = 1;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_GU:
        this.numSelect = 2;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_TI:
        this.numSelect = 3;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_SA:
        this.numSelect = 4;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_TK:
        this.numSelect = 5;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_NA:
        this.numSelect = 6;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_NI:
        this.numSelect = 7;
        break;
      case this.model.kymw0900Component.kymw00Model.COOP_CODE_KU:
        this.numSelect = 8;
        break;
    }
    return this.numSelect;
  }
}
